import {
  COMPASS_PORTAL_CONTAINER_ID,
  HEADLESSUI_PORTAL_ROOT_ID,
  HEADLESSUI_PORTAL_ROOT_Z_INDEX,
  LEGACY_TIPTAP_MODAL_Z_INDEX,
} from "@circle-react/components/QuickPostV3/constants";

export const QUICK_POST_V3_PORTAL_LAYERING_CSS = `#${COMPASS_PORTAL_CONTAINER_ID} { z-index: ${LEGACY_TIPTAP_MODAL_Z_INDEX} !important; }
#${HEADLESSUI_PORTAL_ROOT_ID} { z-index: ${HEADLESSUI_PORTAL_ROOT_Z_INDEX} !important; }`;
